export const clearStorage = () => {
  localStorage.clear();
  window.location.reload();
};

export const setActiveBusiness = (id) =>
  localStorage.setItem("KB_activeBusiness", id);

export const getActiveBusiness = localStorage.getItem("KB_activeBusiness");
